import { StoreProduct, StoreRegion } from "@/types/store"

import ProductPreview from "@modules/products/components/product-preview"

export default function ProductRail({
  product,
  region,
}: {
  product: StoreProduct[]
  region: StoreRegion
}) {
  if (!product || product.length === 0) {
    return null
  }

  return (
    <div className="mt-6 w-full">
      <ul className="grid w-full grid-cols-1 xsmall:grid-cols-2 small:grid-cols-3 medium:grid-cols-4 large:grid-cols-5 gap-3 xsmall:gap-4">
        {product
          .filter((item): item is NonNullable<typeof item> => !!item)
          .slice(0, 5)
          .map(({ id, average_rating, ...productItem }) => (
            <li key={`${id}`} className="h-full">
              <ProductPreview
                product={{ id, ...productItem }}
                region={region}
                isFeatured
                averageRating={
                  typeof average_rating === "number"
                    ? average_rating
                    : undefined
                }
              />
            </li>
          ))}
      </ul>
    </div>
  )
}
